import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import Signals from 'signals';
import templateMarkup from 'raw-loader!./update-endpoint-modal.html';

    

    function UpdateModal(params) {
        var self = this;

        this.parentSignals = params?.signals?.();

        if (_.isEmpty(_.get(this.parentSignals, 'showSingleUpdateModal'))) {
            throw new Error('UpdateModal:: Missing required signals showSingleUpdateModal or showBulkUpdateModal');
        }
        this.signals = ko.observable({
            onShow: new Signals.Signal(),
            onSave: new Signals.Signal(),
            onSaveCallback: new Signals.Signal(),
            onClose: new Signals.Signal(),
            closeModal: new Signals.Signal(),
            onActionSelected: new Signals.Signal(),
        });

        ;
        this.modeMap = {
            bulkActions: {
                widgetName: 'actions-modal',
                title: 'Bulk Actions',
            },
            updateDetails: {
                widgetName: 'endpoint-form',
                title: 'Update Endpoint',
                saveSignal: this.parentSignals.onUpdateEndpoint
            },
            appendTags: {
                widgetName: 'update-tags-form',
                title: 'Append Tags',
                saveSignal: this.parentSignals.onAppendTags
            }
        };

        this.showMode = function(mode, model) {
            this.currentMode = mode;
            var modeObj = this.modeMap[mode];
            this.title(modeObj.title);
            this.bodyModel(model);
            this.bodyWidgetName(modeObj.widgetName);
        };

        this.bodyWidgetName = ko.observable();
        this.title = ko.observable();
        this.bodyModel = ko.observable();

        this.$el = function() {
            return $('#endpoint-update-modal');
        };

        this.enableSave = ko.observable(false);
        this.showSave = ko.observable(false);


        this.parentSignalHandlers = {
            showSingleUpdateModal: function(model) {
                self.showMode('updateDetails', model);
                self.show();
            },
            showBulkUpdateModal: function(model) {
                self.showMode('bulkActions', model);
                self.show();
            }
        };
        this.parentSignals.showSingleUpdateModal.add(this.parentSignalHandlers.showSingleUpdateModal);
        if (_.has(this.parentSignals, 'showBulkUpdateModal')) {
            this.parentSignals.showBulkUpdateModal.add(this.parentSignalHandlers.showBulkUpdateModal);
        }

        this.signalHandlers = {
            onActionSelected: self.showMode.bind(this),
            onSaveCallback: self.onSaveCallback.bind(this)
        };
        this.signals().onActionSelected.add(this.signalHandlers.onActionSelected);
        this.signals().onSaveCallback.add(this.signalHandlers.onSaveCallback);
    }

    UpdateModal.prototype = {
        show: function() {
            this.signals().onShow.dispatch(this.bodyModel());
            this.$el().modal('show');
        },
        close: function() {
            this.$el().modal('hide');
            this.signals().onClose.dispatch();
        },
        save: function() {
            this.signals().onSave.dispatch();
        },
        onSaveCallback: function (model) {
            var saveSignal = _.get(this.modeMap, [this.currentMode, 'saveSignal']);
            if (!_.isEmpty(saveSignal)) {
                saveSignal.dispatch(model);
                this.close();
            }
        },
        dispose: function() {
            this.parentSignals.showSingleUpdateModal.remove(this.parentSignalHandlers.showSingleUpdateModal);
            if (_.has(this.parentSignals, 'showBulkUpdateModal')) {
                this.parentSignals.showBulkUpdateModal.remove(this.parentSignalHandlers.showBulkUpdateModal);
                delete this.parentSignalHandlers;
            }

            this.signals().onActionSelected.remove(this.signalHandlers.onActionSelected);
            this.signals().onSaveCallback.remove(this.signalHandlers.onSaveCallback);
            delete this.signalHandlers;
        }
    };

    export default { viewModel: UpdateModal, template: templateMarkup };
